import { checkGate, getExperiment, getLayer } from '@eventbrite/statsig';
import {
    PlaceOrderAndTosVariant,
    SCROLLABLE_PLACE_ORDER_AND_TOS,
    STATSIG_SYNCHRONOUS_INITIALIZATION_EXPERIMENT,
} from '../constants/statsig';

export const checkEnableOrganizerQuestionsPageInAppsFeatureGate = () =>
    checkGate('checkout_enable_organizer_questions_page_in_apps');

export const checkEnablingExpressWithOptionalQuestionsFeatureGate = () =>
    checkGate('checkout_enabling_express_with_optional_questions');

export const getScrollablePlaceOrderAndTosVariant = () => {
    const { layer, param, defaultValue } = SCROLLABLE_PLACE_ORDER_AND_TOS;
    return getLayer<PlaceOrderAndTosVariant, PlaceOrderAndTosVariant>(
        layer,
        param,
        defaultValue,
    );
};

export const getStatsigSynchronousInitializationExperimentVariant = () =>
    getExperiment(
        STATSIG_SYNCHRONOUS_INITIALIZATION_EXPERIMENT.experimentName,
        STATSIG_SYNCHRONOUS_INITIALIZATION_EXPERIMENT.param,
        STATSIG_SYNCHRONOUS_INITIALIZATION_EXPERIMENT.defaultValue,
    );
